import MatchedMap from 'utilities/src/matchedMap';

import { SiteVariantEnum } from '../../_variants';
import { SiteSizeEnum, type SiteSizeType } from '../../_size';

const buttonClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'bg-site-primary-600'],
  [SiteVariantEnum.Secondary, 'border-site-primary-600 disabled:text-site-neutrals-500'],
  [SiteVariantEnum.Tertiary, 'text-site-primary-600'],
  [SiteVariantEnum.TextOnly, 'text-site-primary-600'],
]);

const buttonHoverClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'hover:bg-site-primary-700 hover:text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'hover:bg-site-primary-600 hover:text-site-neutrals-0'],
  [SiteVariantEnum.Tertiary, 'hover:text-site-primary-500'],
  [SiteVariantEnum.TextOnly, 'hover:text-site-primary-500'],
]);

const buttonActiveClassesMap = new MatchedMap([
  [SiteVariantEnum.Primary, 'active:bg-site-primary-800 active:text-site-neutrals-0'],
  [SiteVariantEnum.Secondary, 'active:border-site-primary-800'],
  [SiteVariantEnum.Tertiary, 'active:text-site-primary-800'],
  [SiteVariantEnum.TextOnly, 'active:text-site-primary-800'],
]);

const buttonShadowClasses = 'focus:shadow-site-primary-200';

/**
 * Size per Variants
 */

const buttonPrimarySizeClassesMap = new MatchedMap([
  [SiteSizeEnum.Small, 'text-site-neutrals-900 focus:text-site-neutrals-900 focus:bg-site-primary-500'],
  [SiteSizeEnum.Medium, 'text-site-neutrals-900 focus:text-site-neutrals-900 focus:bg-site-primary-500'],
  [SiteSizeEnum.Large, 'text-site-neutrals-0 focus:text-site-neutrals-0'],
  [SiteSizeEnum.XLarge, 'text-site-neutrals-0 focus:text-site-neutrals-0'],
]);

/**
 * Site Theme / Brand Dark Button Size Variant
 */

const buttonSizeClassesMap = (size: SiteSizeType) =>
  new MatchedMap([
    [SiteVariantEnum.Primary, buttonPrimarySizeClassesMap.get(SiteSizeEnum[size])],
    [SiteVariantEnum.Secondary, ''],
    [SiteVariantEnum.Tertiary, ''],
    [SiteVariantEnum.TextOnly, ''],
  ]);

/**
 * Site Theme / Brand Dark Button Color Variant
 */

const buttonSiteBrandDarkTheme = (size: SiteSizeType) => ({
  buttonSiteVariantColorClasses: [
    buttonClassesMap,
    buttonHoverClassesMap,
    buttonActiveClassesMap,
    buttonSizeClassesMap(size),
  ],
  buttonSiteVariantColorShadowClasses: buttonShadowClasses,
});

export default buttonSiteBrandDarkTheme;
